const cartNp = {
  title: 'मेरो खरिद झोलि',
  clearAll: 'सबै हटाउनुहोस्',
  itemsInBag: (n) => `${n} वस्तुहरू तपाईँको झोलिमा छन्`,
  sectionCartItems: 'झोलिमा राखिएका वस्तुहरू',
  continueShopping: 'किनमेल जारी राख्नुहोस्',
  orderSummary: 'अर्डर सारांश',
  subtotal: 'उप-योग',
  delivery: 'डेलिभरी शुल्क',
  free: 'फ्री',
  discount: 'छुट',
  total: 'जम्मा',
  couponPlaceholder: 'कुपन कोड हाल्नुहोस्',
  applyCoupon: 'कुपन प्रयोग गर्नुहोस्',
  proceedCheckout: 'चेकआउटमा जानुहोस्',
  trust: {
    securePayment: '१००% सुरक्षित भुक्तानी',
    fastDelivery: 'छिटो डेलिभरी',
    cod: 'क्याश अन डेलिभरी'
  },
  empty: {
    title: 'तपाईंको कार्ट खाली छ',
    subtitle: 'देखिन्छ कि तपाईंले अझै कुनै वस्तु थप्नुभएन।\nहाम्रा उत्कृष्ट वस्तुहरू हेर्नुहोस् र किनमेल सुरु गर्नुहोस्!',
    cta: 'किनमेल सुरु गर्नुहोस्'
  },
  item: {
    inStock: 'स्टकमा छ',
    removed: 'वस्तु कार्टबाट हटाइयो'
  },
  cleared: 'सबै वस्तुहरू कार्टबाट हटाइयो'
};

export default cartNp;


